import { CerFormAdapter } from '@cer/cer-form/cer-form-adapter';
import { CerFormView } from '@cer/cer-form/cer-form-view';
import { FieldWidthEnum } from 'src/cer/cer-data/cer-data-types';

export class VoucherApprovalForm extends CerFormAdapter {

  override view(): CerFormView {
    return  new CerFormView({
      viewMetadata: {
      name: 'voucher-approval', dataApiName: 'VoucherApproval', text: 'Godkendelser af bilag',
      primaryKey: 'id', titleFields: ['id'], baseFields: ['id', 'history']
    },
    fieldMetadata:
      [
        { name: 'voucher', text: 'Bilag', tooltipText: 'Godkendt bilag', required: true, allowEdit: true, allowEditOnAdd: true, widthType: FieldWidthEnum.M, foreignKeyField: 'id', foreignKeyValue: 'txt', foreignKeyTableName: 'VoucherView' },
        { name: 'policy', text: 'Politik', tooltipText: 'Bruger', required: true, allowEdit: true, allowEditOnAdd: true, widthType: FieldWidthEnum.M, foreignKeyField: 'id', foreignKeyValue: 'name', foreignKeyTableName: 'VoucherApprovalPolicy' },
        { name: 'approver', text: 'Godkender', tooltipText: 'Bruger', required: true, widthType: FieldWidthEnum.M, foreignKeyField: 'id', foreignKeyValue: 'shortName', foreignKeyTableName: 'User', foreignKeyTableParams: ['$filterSystemRows'] },
        { name: 'approved', text: 'Godkendt', defaultValue: false, format: 'CheckBox' }
      ]
    });
  }
}
